import { useState } from "react"
import { useScrollReveal } from "@/hooks/useScrollReveal"
import {ChevronDown} from 'lucide-react'

const faqs = [
  {
    q: "O que é o EW Pass?",
    a: "O EW Pass é a plataforma completa de inglês da English Work. Inclui mais de 400 horas de aulas, tutora virtual com IA, aulas ao vivo semanais, aplicativos para celular, comunidade e certificados.",
  },
  {
    q: "Preciso ter algum nível de inglês para começar?",
    a: "Não! O EW Pass atende desde o nível iniciante até o avançado. A plataforma adapta o conteúdo ao seu nível atual.",
  },
  {
    q: "Como funciona a Lucy IA?",
    a: "A Lucy é a tutora virtual da English Work, disponível 24 horas por dia via WhatsApp. Ela tira dúvidas, pratica conversação e ajuda no aprendizado de forma personalizada.",
  },
  {
    q: "Posso estudar pelo celular?",
    a: "Sim! O EW Pass possui aplicativos nativos para iOS e Android, permitindo que você estude em qualquer lugar e a qualquer momento.",
  },
  {
    q: "Qual a duração do acesso?",
    a: "O acesso ao EW Pass é contínuo enquanto sua assinatura estiver ativa. Você pode estudar no seu ritmo, sem prazo de conclusão.",
  },
  {
    q: "A English Work oferece certificado?",
    a: "Sim! Ao concluir cada módulo, você recebe certificados de conclusão que atestam sua evolução no idioma.",
  },
]

export default function FAQSection() {
  const { ref, isVisible } = useScrollReveal()
  const [openIndex, setOpenIndex] = useState<number | null>(null)

  return (
    <section id="faq" className="py-20 md:py-28 bg-gray-50">
      <div ref={ref} className="max-w-4xl mx-auto px-5">
        <div
          className={`text-center mb-14 transition-all duration-700 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
          }`}
        >
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-gray-900 mb-4">
            Perguntas <span style={{ color: "#0E8EA0" }}>frequentes</span>
          </h2>
          <div className="w-20 h-1 rounded-full mx-auto" style={{ backgroundColor: "#B038B2" }} />
        </div>

        <div className="grid md:grid-cols-2 gap-4">
          {faqs.map((faq, i) => {
            const isOpen = openIndex === i
            return (
              <div
                key={i}
                className={`bg-white rounded-xl overflow-hidden transition-all duration-500 ${
                  isOpen ? "shadow-lg" : "shadow-sm hover:shadow-md"
                } ${
                  isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
                }`}
                style={{ transitionDelay: isVisible ? `${(i + 1) * 60}ms` : "0ms" }}
              >
                <button
                  onClick={() => setOpenIndex(isOpen ? null : i)}
                  className="w-full flex items-center justify-between p-5 text-left"
                >
                  <span className="text-gray-800 font-semibold text-sm pr-4">{faq.q}</span>
                  <ChevronDown
                    size={20}
                    className={`flex-shrink-0 transition-transform duration-300 ${
                      isOpen ? "rotate-180" : ""
                    }`}
                    style={{ color: "#0E8EA0" }}
                  />
                </button>
                <div
                  className={`transition-all duration-300 overflow-hidden ${
                    isOpen ? "max-h-60 opacity-100" : "max-h-0 opacity-0"
                  }`}
                >
                  <p className="px-5 pb-5 text-gray-500 text-sm leading-relaxed">{faq.a}</p>
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}
